<template>
  <div class="fotoportada-container" ref="containerRef">
    <!-- Sobre y tarjeta -->
    <div class="contenedor-sobre-tarjeta" ref="sobreRef">
      <img src="@/assets/sobre2.avif" alt="Sobre decorativo" class="imagen-sobre" />

      <div class="tarjeta-decorativa" ref="tarjetaRef">
        <img src="@/assets/sello.avif" alt="Sello" class="sello-tarjeta" />
        <div class="nombres-tarjeta">
          <div class="fecha-tarjeta" ref="textoRef">
            <span class="dia">20</span><br />
            <span class="mes">Noviembre</span><br />
            <span class="año">2026</span><br /><br />
            <span class="nombres-titulo">Patricia y Erik</span><br /><br />
            Tenemos el gusto de invitarte<br />a celebrar con nosotros.
          </div>
        </div>
      </div>
    </div>

    <!-- Fondo -->
    <img :src="require('@/assets/fond.jpg')" alt="Fondo textura" class="fondo-textura" />

    <!-- FOTO DE LA PAREJA -->
<div class="contenedor-foto">
  <img :src="require('@/assets/IMG_0102.webp')" alt="Gabriela y Héctor" class="foto-pareja" ref="fotoRef" />
</div>

<!-- SELLO QUE SUBE AL HACER SCROLL -->
<div class="sello-contenedor" ref="selloRef">
  <img src="@/assets/etiq.avif" alt="Etiqueta" class="sello-imagen" ref="selloImagenRef" />
</div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'PortadaInvitacion-v',
  setup() {
    const containerRef = ref(null)
    const sobreRef = ref(null)
    const tarjetaRef = ref(null)
    const textoRef = ref(null)
    const fotoRef = ref(null)
    const selloImagenRef = ref(null)

    onMounted(() => {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Animaciones escalonadas
            gsap.timeline()
              .fromTo(
                sobreRef.value,
                { x: -200, opacity: 0 },
                { x: 0, opacity: 1, duration: 1.2, ease: 'power3.out' }
              )
              .fromTo(
                tarjetaRef.value,
                { opacity: 0, y: 20 },
                { opacity: 1, y: 0, duration: 1.4, ease: 'power2.out' },
                "+=0.2"
              )
              .fromTo(
                textoRef.value,
                { opacity: 0, scale: 0.8 },
                { opacity: 1, scale: 1, duration: 1.6, ease: 'back.out(1.7)' },
                "+=0.2"
              );

            obs.unobserve(entry.target)
          }
        })
      }, { threshold: 0.4 })

      observer.observe(containerRef.value)

     // Movimiento vertical del sello cuando entra al viewport
gsap.to(selloImagenRef.value, {
  y: -40,
  ease: 'power1.out',
  scrollTrigger: {
    trigger: selloImagenRef.value,     // ya no containerRef
    start: 'top 90%',                  // cuando el sello entra a pantalla
    end: 'top 50%',
    scrub: 0.2
  }
})

// Rotación suave mientras haces scroll
gsap.to(selloImagenRef.value, {
  rotation: -5,
  scrollTrigger: {
    trigger: selloImagenRef.value,
    start: 'top 90%',
    end: 'top 40%',
    scrub: 0.3
  }
})


      // Animación de la foto cuando entra al viewport
   // Foto portada animada con ScrollTrigger
gsap.from(fotoRef.value, {
  scrollTrigger: {
    trigger: fotoRef.value,
    start: 'top 80%',
    toggleActions: 'play none none none',
  },
  opacity: 0,
  y: 100,
  scale: 0.9,
  duration: 1.8,
  ease: 'power4.out'
})

    })

    return {
      containerRef,
      sobreRef,
      tarjetaRef,
      textoRef,
      fotoRef,
      selloImagenRef
    }
  }
}
</script>

<style scoped>
.fotoportada-container {
  position: relative;
  width: 100%;
  top: -60px;
  min-height: 100vh;
  overflow: hidden;
margin-bottom: -60px;}

.fondo-textura {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}
.sello-contenedor {
  display: flex;
  justify-content: center;
  margin-top: 0px; /* justo después de la tarjeta */
  z-index: 2;
}
.contenedor-foto {
  display: flex;
  justify-content: center;
  margin-top: 750px;
  z-index: 2;
  margin-bottom: -90px;
  position: relative;
}

.sello-imagen {
  width: 100px;
  height: auto;
  z-index: 10;
  opacity: 1;
  position: relative;
}

.foto-pareja {
  position: relative;
  display: block;
  width: 100%;
  max-width: 340px;
  margin: 40px auto 0;
  border-radius: 10px;
  z-index: 2;
}

.contenedor-sobre-tarjeta {
  position: absolute;
  top: 40px;
  left: 0;
  z-index: 4;
  display: flex;
  align-items: flex-start;
}

.imagen-sobre {
  width: 320px;
  height: auto;
  margin-left: -5px;
  z-index: 1;
}

.tarjeta-decorativa {
  background-color: #78866b;
  color: white;
  padding: 90px 20px 30px;
  border-radius: 0 30px 30px 0;
  font-family: 'say2';
  font-size: 14px;
  overflow: visible;
  text-align: center;
  position: absolute;
  top: 220px;
  left: 85px;
  z-index: 3;
  width: 320px;
  min-height: 460px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  background-image: url("@/assets/ramita.avif");
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: 80px;
}



.sello-tarjeta {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  z-index: 14;
}

.nombres-tarjeta {
  
  margin-top: 10px;
  line-height: 1.3;
}

.fecha-tarjeta {
  font-family: 'padres';
  font-size: 14px;
  color: #d8d8b6;
  margin-top:-40px;
  margin-bottom: 40px;
}

.fecha-tarjeta .dia {
  font-size: 18px;
  font-weight: bold;
}

.fecha-tarjeta .mes {
  font-size: 16px;
  font-style: italic;
}

.fecha-tarjeta .año {
  font-size: 12px;
}

.nombres-titulo {
  font-family: 'corinthia', cursive;
  font-size: 52px; /* Se subió ligeramente para mejorar la legibilidad de la cursiva */
  color: #ffffff;
  line-height: 1.4; /* Se redujo para evitar un espacio excesivo arriba y abajo */
  margin-top: 10px;
}
</style>
